import type { FC, ReactNode } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import type { Agreement } from "../api/partners";
import { isAgreementExpired } from "./isAgreementExpired";

export const ValidityText: FC<{ expired: boolean; small?: boolean; children: ReactNode }> = ({
  expired,
  small = false,
  children,
}) => (
  <Box
    component="span"
    sx={{
      fontSize: theme => (small ? theme.typography.pxToRem(12) : "inherit"),
      color: theme => (expired ? theme.palette.error.main : theme.palette.text.secondary),
    }}
  >
    {children}
  </Box>
);

export const AgreementDate: FC<{ agreement: Pick<Agreement, "validUntil"> }> = ({ agreement }) => {
  const { t, formatDate } = useTranslation();
  if (!agreement.validUntil) return null;
  const date = formatDate(agreement.validUntil);
  const expired = isAgreementExpired(agreement);
  return (
    <ValidityText expired={expired} small>
      {" "}
      ({expired ? t("System.SuppliersAgreements.Agreement.Expired", { date }) : date})
    </ValidityText>
  );
};
